import React from "react";
import { Modal, Form } from "react-bootstrap";

interface Props {
  show: boolean;
  handleClose: () => void;
  policyData: {
    returnDays: number;
    exchangeDays: number;
    buybackAfter: number;
  };
  onSave: (data: {
    returnDays: number;
    exchangeDays: number;
    buybackAfter: number;
  }) => void;
}
const EditReturnPolicyModal: React.FC<Props> = ({
  show,
  handleClose,
  policyData,
  onSave,
  
}) => {
  const [formData, setFormData] = React.useState({
    returnDays: policyData?.returnDays?.toString(),
    exchangeDays: policyData?.exchangeDays?.toString(),
    buybackAfter: policyData?.buybackAfter?.toString(),
  });

  const [errors, setErrors,] = React.useState({
    returnDays: "",
    exchangeDays: "",
    buybackAfter: "",
  });

const [isSubmitting, setIsSubmitting] = React.useState(false);

  React.useEffect(() => {
    if (show) {
      setFormData({
        returnDays: policyData?.returnDays?.toString(),
        exchangeDays: policyData?.exchangeDays?.toString(),
        buybackAfter: policyData?.buybackAfter?.toString(),
      });
      setErrors({
        returnDays: "",
        exchangeDays: "",
        buybackAfter: "",
      });
    }
  }, [show]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    if (/^\d*$/.test(value)) {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
      setErrors((prev) => ({
        ...prev,
        [name]: "",
      }));
    }
  };

  const handleSubmit = async () => {
    const newErrors: any = {};

    if (!formData.returnDays.trim()) newErrors.returnDays = "Required";
    if (!formData.exchangeDays.trim()) newErrors.exchangeDays = "Required";
    if (!formData.buybackAfter.trim()) newErrors.buybackAfter = "Required";

    setErrors(newErrors);

    if (Object.keys(newErrors).length > 0) return;
    setIsSubmitting(true);

   try {
    await onSave({
      returnDays: parseInt(formData.returnDays),
      exchangeDays: parseInt(formData.exchangeDays),
      buybackAfter: parseInt(formData.buybackAfter),
    });
    setIsSubmitting(false);
  } catch (error) {
    console.error("Save failed", error);
    setIsSubmitting(false);
  }
};

  return (
    <Modal
      show={show}
      onHide={handleClose}
      className="fade"
      dialogClassName="modal-dialog-centered"
      backdrop="static"
    >
      <Modal.Header closeButton>
        <Modal.Title className="text-black">Update Policy Setting</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <div className="row">
            <div className="col-md-4 mb-3">
              <Form.Label>Return Within (days) <span style={{color:"red"}}>*</span></Form.Label>
              <Form.Control
                type="text"
                 pattern="[0-9]*"
                name="returnDays"
                maxLength={3}
                value={formData.returnDays}
                onChange={handleChange}
                isInvalid={!!errors.returnDays}
                className="form-control form-control-sm"
              />
              <Form.Control.Feedback type="invalid">
                {errors.returnDays}
              </Form.Control.Feedback>
            </div>

            <div className="col-md-4 mb-3">
              <Form.Label>Exchange After (days) <span style={{color:"red"}}>*</span></Form.Label>
              <Form.Control
                type="text"
                 pattern="[0-9]*"
                maxLength={3}
                name="exchangeDays"
                value={formData.exchangeDays}
                onChange={handleChange}
                isInvalid={!!errors.exchangeDays}
                className="form-control form-control-sm"
              />
              <Form.Control.Feedback type="invalid">
                {errors.exchangeDays}
              </Form.Control.Feedback>
            </div>

            <div className="col-md-4 mb-3">
              <Form.Label>Buyback After (days) <span style={{color:"red"}}>*</span></Form.Label>
              <Form.Control
                 pattern="[0-9]*"
                maxLength={3}
                type="text"
                name="buybackAfter"
                value={formData.buybackAfter}
                onChange={handleChange}
                isInvalid={!!errors.buybackAfter}
                className="form-control form-control-sm"
              />
              <Form.Control.Feedback type="invalid">
                {errors.buybackAfter}
              </Form.Control.Feedback>
            </div>
          </div>

          <div className="d-flex justify-content-end align-items-end mt-4">
            <button
              type="button"
              className="btn add-btn me-1"
              onClick={handleClose}
            >
              Cancel
            </button>
            <button
              type="button"
              className="btn submit-btn"
              onClick={handleSubmit}
              disabled={isSubmitting}
            >
                {isSubmitting ? "Updating..." : "Update"}
            </button>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default EditReturnPolicyModal;
